import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import lines from '../../images/diagonal-pattern-large.svg'
import styles from './title-content-box.module.scss'
import shared from '../shared.module.scss'

const TitleContentBox = ({
  // TitleContentBox Props
  title,
  titlePosition,
  content,
  children,

  // Section Props
  className,
  marginBottom,
  containerFluid,
  textColor,
  backgroundColor,
}) => (
  <section
    className={ classNames( styles.section, {
      [ shared.margin ]: marginBottom,
      [ styles.titleStart ]: titlePosition === 'start',
      [ styles.titleCenter ]: titlePosition === 'center',
      [ styles.titleEnd ]: titlePosition === 'end',
    }, className ) }
    style={{ color: textColor, backgroundColor }}
  >
    <Container className={ styles.container } fluid={ containerFluid }>
      <img className={ styles.lines } src={ lines } alt="" />

      <h2 className={ styles.title } >
        { title }
      </h2>

      <Row>
        <Col
          className={ styles.content }
          xs={ 12 }
          md={{ span: 10, pull: 1 }}
        >
          { content ? (
            <div dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            children
          )}
        </Col>
      </Row>
    </Container>
  </section>
)

TitleContentBox.propTypes = {
  // TitleContentBox Props
  title: PropTypes.string.isRequired,
  titlePosition: PropTypes.oneOf([ '', 'start', 'center', 'end' ]),
  content: PropTypes.string,
  children: PropTypes.node,

  // Section Props
  className: PropTypes.string,
  marginBottom: PropTypes.bool,
  containerFluid: PropTypes.bool,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
}

TitleContentBox.defaultProps = {
  // TitleContentBox Props
  titlePosition: '',
  content: '',
  children: false,
  
  // Section Props
  className: '',
  marginBottom: true,
  containerFluid: false,
  textColor: '',
  backgroundColor: '',
}

export default TitleContentBox